<template>
  <div class="info-slot-container">
    <feather-icon
      v-if="!isLoadedChart"
      icon="XIcon"
      class="ml-auto float-rigth"
      style="cursor: pointer"
      size="25"
      @click="$emit('update:selectedObject', null)"
    />
    <div class="mx-2">
      <div class="cam-container">
        <div class="cam-container-inner">
          <cam-slot
            v-if="selectedObject.camera_data"
            :data="selectedObject.camera_data"
            :type="cam_type"
            :config="{ layout: 'alarm', synced: false }"
          />
        </div>
      </div>

      <div class="px-2 mt-1">
        <div class="row">
          <div ref="swiperContainer" class="swiper ar-carousel">
            <div class="swiper-wrapper">
              <div
                v-for="(image, index) in medias"
                :key="`slide-${index}`"
                class="swiper-slide"
                style="position: relative;"
              >
                <div style="position: absolute; width: 100%; height: 100%; z-index: 3;">
                  <div style="
                    color: white;
                    width: 100%;
                    background-color: rgba(0,0,0,0) !important;
                    text-shadow: 1px 2px #000;
                    padding: .5rem;
                    top: 0;
                    background: linear-gradient(0deg, transparent 0%, rgba(0, 0, 0, 0.5) 95%);">
                    <span>
                      {{ selectedObject.camera_name }}
                      <br>
                      {{ selectedObject.type_alarm }}
                    </span>
                    <span style="float: right;">{{
                        formatDateAssigned(selectedObject.created_at)
                      }}</span>
                  </div>

                  <div style="
                    position: absolute;
                    color: white;
                    width: 100%;
                    background-color: rgba(0,0,0,0) !important;
                    text-shadow: 1px 2px #000;
                    padding: .5rem;
                    bottom: 0;
                    background: linear-gradient(transparent, rgba(0, 0, 0, 0.5));">
                    <span style="bottom: 0;">{{ selectedObject.priority }}</span>
                  </div>
                </div>
                <img style="width: 100%" :src="image.url" v-if="image.url"/>
              </div>
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </div>
      </div>
      <table class="table table-sm mt-1">
        <tr>
          <th>{{ $t('intelexvision_event.alarm_category') }}:</th>
          <td>{{ selectedObject.alarm_category }}</td>
        </tr>
        <tr>
          <th>{{ $t('intelexvision_event.type_alarm') }}:</th>
          <td>{{ selectedObject.type_alarm }}</td>
        </tr>
        <tr>
          <th>{{ $t('intelexvision_event.matched_rules') }}:</th>
          <td>{{ selectedObject.matched_rules }}</td>
        </tr>
        <tr>
          <th>{{ $t('intelexvision_event.intelexvision_server') }}:</th>
          <td>{{ selectedObject.intelexvision_server.description }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle";
import "swiper/swiper-bundle.css";
import moment from "moment-timezone";
import CamSlot from "../slots/CamSlot.vue";
import {ref, onMounted, onBeforeUnmount} from "@vue/composition-api";

export default {
  name: "ARTableData",
  props: {
    selectedObject: Object,
    isLoadedChart: {
      default: false,
      type: Boolean
    }
  },
  components: {
    CamSlot,
  },
  setup(props) {
    const medias = ref([]);
    const swiperContainer = ref(null);
    let swiper = null;

    medias.value = JSON.parse(JSON.stringify(props.selectedObject.media));

    const formatDateAssigned = (value) => {
      const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
      return formattedDate;
    };

    onMounted(() => {
      swiper = new Swiper(swiperContainer.value, {
        slidesPerView: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    });

    onBeforeUnmount(() => {
      swiper?.destroy(true, true);
    });

    return {
      formatDateAssigned,
      medias,
      swiperContainer,
      cam_type: "cam_pa",
    };
  }
};
</script>

<style lang="scss" scoped>
.info-slot-container {
  max-height: 100%;
  overflow: auto;
}

.cam-container-inner {
  width: 100%;
  height: 100%;
  position: absolute;
}

.cam-container {
  width: 100%;
  height: 16rem;
  position: relative;
}
</style>
